import React, { useState, useEffect } from 'react';
import {Link, Navigate, useParams} from 'react-router-dom';
import Navbar from '../Components/Navbar/navbar.jsx';
import './editarcliente.css';
import firebase from '../Config/firebase.js';
import { collection, doc, getDoc, getFirestore, setDoc, query, orderBy, getDocs } from 'firebase/firestore';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function MostrarProcesso(props){
    let cpfaux = '';
    const [p2,setP2] = useState([]);
    const [cartn,setCartn] = useState('');
    const [carts,setCarts] = useState('');
    const [cartc,setCartc] = useState('');
    const [nome,setNome] = useState('');
    const [email,setEmail] = useState('');
    const [fone,setFone] = useState('');
    const [siape,setSiape] = useState('');
    const [cpf,setCpf] = useState('');
    const [endereco,setEndereco] = useState('');
    const [bairro,setBairro] = useState('');
    const [cidade,setCidade] = useState('');
    const [estado,setEstado] = useState('');
    const [cep,setCep] = useState('');
    const [lotacao,setLotacao] = useState('');
    const [processo,setProcesso] = useState('');
    const [obs1,setObs1] = useState('');
    const [valor,setValor] = useState('');

    const [acoes,setAcoes] = useState([]);
    const [busca,setBusca] = useState([]);
    const [excluido,setExcluido] = useState([]);
    
    const [mensagem,setMensagem] = useState('');
    const [sucesso,setSucesso] = useState('N');
//    const [txteproc,setTxteproc] = useState('https://eproc.jfrj.jus.br/eproc/externo_controlador.php?acao=processo_seleciona_publica&acao_origem=processo_consulta_publica&acao_retorno=processo_consulta_publica&num_processo=')
    const [txteproc,setTxteproc] = useState('https://eproc-consulta.jfrj.jus.br/eproc/externo_controlador.php?acao=processo_consulta_publica')
    const params = useParams();
    const db = getFirestore();

     useEffect(() =>{
          const cartdado = [];
          const fetchData = async () => {

          const docRef = doc(db, 'clientes', params.id);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
             cartdado.push(docSnap.data().nome);
             cartdado.push(docSnap.data().siape);
             setCartn(docSnap.data().nome);
             setCarts(docSnap.data().siape);
             setCartc(docSnap.data().cpf);
             setP2(cartdado);
             setNome(docSnap.data().nome);
             setEmail(docSnap.data().email);
             setFone(docSnap.data().fone);
             setSiape(docSnap.data().siape);
             setCpf(docSnap.data().cpf);
             cpfaux = docSnap.data().cpf;
             setProcesso(docSnap.data().processo);
             setValor(docSnap.data().valor);
             setEndereco(docSnap.data().endereco);
             setBairro(docSnap.data().bairro);
             setCidade(docSnap.data().cidade);
             setEstado(docSnap.data().estado);
             setCep(docSnap.data().cep);
             setLotacao(docSnap.data().lotacao);
             setObs1(docSnap.data().obs1);
             setTxteproc('https://eproc.jfrj.jus.br/eproc/externo_controlador.php?acao=processo_seleciona_publica&acao_origem=processo_consulta_publica&acao_retorno=processo_consulta_publica&num_processo=' + docSnap.data().processo)
             //setTxteproc('https://eproc-consulta.jfrj.jus.br/eproc/externo_controlador.php?acao=processo_consulta_publica')
             console.log("Dado do Documento:", docSnap.data().nome);
           
          } else {
            // docSnap.data() will be undefined in this case
            console.log("Não encontrado!");
          }
          setP2(cartdado);
          console.log("P2:", cartdado);
        }
        fetchData();
     }, [])
      useEffect(() => {
                  let listapro = [];
                  const fetchData = async () => {
                    const db = getFirestore();
                    const clientesRef = collection(db, 'acoes');
                    const q = query(clientesRef, orderBy('cpf'));
                    const snapshot = await getDocs(q);
                    
                    snapshot.forEach((doc) => {
                      if (doc.data().cpf.indexOf(busca) >= 0){
                       if (doc.data().cpf === cpfaux){
                       listapro.push({
                        id: doc.id,
                        cpf: doc.data().cpf,
                        processo: doc.data().processo,
                        acao: doc.data().acao,
                        valor: doc.data().valor,
                        situacao: doc.data().situacao,
                        data: doc.data().data
                       })
                     }
                      }
                    });
                    setAcoes(listapro);
                  };
                
                  fetchData();
              }, [busca,excluido]);

     function AlterarCliente(){
        if (nome.length === 0){
            setMensagem('Informe o nome');
        }
        else{
            const docRef = setDoc(doc(db, 'clientes', params.id),{
              nome: nome,
              processo: processo,
              valor: valor,
              siape: siape,
              cpf: cpf,
              endereco: endereco,
              bairro: bairro,
              cidade: cidade,
              estado: estado,
              cep: cep,
              fone: fone,
              email: email,
              lotacao: lotacao,
              obs1: obs1,
              alter: 'X'
            })
            .then((docRef) => {
              setMensagem('');
              setSucesso('S');
            })
            .catch((error) => {
              setMensagem(error);
              setSucesso('N');
            })
      }
      }

    function OpeninNewTab(){
      const win = window.open(txteproc, '_blank');
    }

    function OpeninNewTab2(){    
      const txteproc = 'https://www.sintuff.org.br/entenda';
      const win = window.open(txteproc, '_blank');
    }

    const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(processo);
      alert('Nº do processo copiado para a área de transferência!');
    } catch (err) {
      console.error('Falha ao copiar texto: ', err);
      alert('Erro ao copiar texto.');
    }
    }


    return <div>
 
        <div className="container-fluid titulo">
          <div className="offset-md-1 offset-lg-1 col-lg-10 mt-5">  
            <form>
                    <div>
                    <label htmlFor="exampleInputEmail1" className="form-label teste-lb">Nome</label>
                    <label htmlFor="exampleInputEmail1" className="form-label teste-lb20">{nome}</label>
                    </div>
                    <div>
                    <label htmlFor="exampleInputEmail1" className="form-label teste-lb">Siape</label>
                    <label htmlFor="exampleInputEmail1" className="form-label teste-lb21">{siape}</label>
                    </div>
                    <div>
                    <label htmlFor="exampleInputEmail1" className="form-label teste-lb">CPF</label>
                    <label htmlFor="exampleInputEmail1" className="form-label teste-lb22">{cpf}</label>
                    </div>         
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3 teste-lb1">Endereco</label>
                    <input onChange={(e) => setEndereco(e.target.value)} value={endereco} type="text" className="form-control bg-secondary-subtle teste-lb1 w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  <div className="tipo1">
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3 teste-lb1">Bairro</label>
                    <input onChange={(e) => setCidade(e.target.value)} value={cidade} type="text" className="form-control bg-secondary-subtle teste-lb1 w-100" id="exampleInputEmail1" aria-describedby="emailHelp"></input>                    
                  </div>
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3 teste-lb1">Cidade</label>
                    <input onChange={(e) => setBairro(e.target.value)} value={bairro} type="text" className="form-control bg-secondary-subtle teste-lb1 w-100" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3 teste-lb1">Estado</label>
                    <input onChange={(e) => setEstado(e.target.value)} value={estado} type="text" className="form-control bg-secondary-subtle teste-lb1 w-25" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3 teste-lb1">CEP</label>
                    <input onChange={(e) => setCep(e.target.value)} value={cep} type="text" className="form-control bg-secondary-subtle teste-lb1 w-50" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  <div className="tipo12">
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3 teste-lb1">Fone</label>
                    <input onChange={(e) => setFone(e.target.value)} value={fone} type="text" className="form-control bg-secondary-subtle teste-lb1 w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                  </div>
                  </div>
  
                    <label htmlFor="exampleInputEmail1" className="form-label pt-3 teste-lb1">Email</label>
                    <input onChange={(e) => setEmail(e.target.value)} value={email} type="text" className="form-control bg-secondary-subtle teste-lb1 w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>

                    <label htmlFor="exampleInputEmail1" className="form-label pt-3 teste-lb1">Lotação</label>
                    <input onChange={(e) => setLotacao(e.target.value)} value={lotacao} type="text" className="form-control bg-secondary-subtle teste-lb1 w-75" id="exampleInputEmail1" aria-describedby="emailHelp"></input>
                                                  

                       
 
                    <div>
                    
                    
                    </div>
                    <div>
                    {obs1 ? <label className="teste-lb8 mt-2"> Aviso: {obs1} </label>: null}
                    </div>
                                        
                    <div className = "text-center ms-0 mt-5">
                      <Link to="/app" className="btn btn-outline-primary btn-mos1">Descartar Alterações</Link>
                      <button onClick={AlterarCliente} type="button" className="btn btn-primary btn-mos2">Salvar</button>
                    </div>

                

                {mensagem.length>0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                
            </form>
            <table className="table table-hover table-bordered mt-3">
                <thead>
                  <tr className="table-secondary">
            
                    <th scope="col">Ação</th>
                    <th scope="col">Processo</th>
                    <th scope="col">Data</th>
                    <th scope="col">Valor</th>
                    <th scope="col">Situacao</th>
                    <th scope="col" className='col-acao'></th>
                  </tr>
                </thead>
                <tbody>
            
                {
                    acoes.map(function(proce){
                        return <tr  key={proce.id}>
            
                        <td>{proce.acao}</td>
                        <td>{proce.processo}</td>
                        <td>{proce.data}</td>
                        <td>{proce.valor}</td>
                        <td>{proce.situacao}</td>
                        <td>
                           <Link to= '#' onClick={OpeninNewTab}><i className="fa-solid fa-duotone fa-light - fa-eye icone-acao"></i></Link>
            
                        </td>
                       
                      </tr>    
                    })
                }
            
                  
                </tbody>
              </table>
          </div>
        </div>  
    </div>
  }
  export default MostrarProcesso;